// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import ActivityFormController from "./activity_form_controller"
application.register("activity-form", ActivityFormController)

import ActivityRepeaterController from "./activity_repeater_controller"
application.register("activity-repeater", ActivityRepeaterController)

import AffiliateGroupShowController from "./affiliate_group_show_controller"
application.register("affiliate-group-show", AffiliateGroupShowController)

import AffiliateLinkController from "./affiliate_link_controller"
application.register("affiliate-link", AffiliateLinkController)

import AffiliateMfaController from "./affiliate_mfa_controller"
application.register("affiliate-mfa", AffiliateMfaController)

import AffiliateSettingsController from "./affiliate_settings_controller"
application.register("affiliate-settings", AffiliateSettingsController)

import AffiliateSelectController from "./affiliate_select_controller"
application.register("affiliate-select", AffiliateSelectController)

import AffiliateTabsController from "./affiliate_tabs_controller"
application.register("affiliate-tabs", AffiliateTabsController)

import AlertController from "./alert_controller"
application.register("alert", AlertController)

import BessVolumeController from "./bess_volume_controller"
application.register("bess-volume", BessVolumeController)

import BessVolumePrintController from "./bess_volume_print_controller"
application.register("bess-volume-print", BessVolumePrintController)

import C3vizController from "./c3viz_controller"
application.register("c3viz", C3vizController)

import CalendarActionsController from "./calendar_actions_controller"
application.register("calendar-actions", CalendarActionsController)

import CableNotificationsController from "./cable_notifications_controller"
application.register("cable-notifications", CableNotificationsController)

import DevCableNotificationController from "./dev_cable_notification_controller"
application.register("dev-cable-notification", DevCableNotificationController)

import CheckboxController from "./checkbox_controller"
application.register("checkbox", CheckboxController)

import ClickableAffiliateRowController from "./clickable_affiliate_row_controller"
application.register("clickable-affiliate-row", ClickableAffiliateRowController)

import ClickableRowController from "./clickable_row_controller"
application.register("clickable-row", ClickableRowController)

import ClipboardController from "./clipboard_controller"
application.register("clipboard", ClipboardController)

import CollapseToggleController from "./collapse_toggle_controller"
application.register("collapse-toggle", CollapseToggleController)

import ConditionalFieldController from "./conditional_field_controller"
application.register("conditional-field", ConditionalFieldController)

import ConfirmationController from "./confirmation_controller"
application.register("confirmation", ConfirmationController)

import FlatpickrController from "./flatpickr_controller"
application.register("flatpickr", FlatpickrController)

import FormVisibilityController from "./form_visibility_controller"
application.register("form-visibility", FormVisibilityController)

import GenericRevealController from "./generic_reveal_controller"
application.register("generic-reveal", GenericRevealController)

import GuardianApprovalFormController from "./guardian_approval_form_controller"
application.register("guardian-approval-form", GuardianApprovalFormController)

import IncidentContextController from "./incident_context_controller"
application.register("incident-context", IncidentContextController)

import LeaderBoardHistogramController from "./leader_board_histogram_controller"
application.register("leader-board-histogram", LeaderBoardHistogramController)

import LeaderBoardThemeController from "./leader_board_theme_controller"
application.register("leader-board-theme", LeaderBoardThemeController)

import ModalFormController from "./modal_form_controller"
application.register("modal-form", ModalFormController)

import MultiSelectFieldController from "./multi_select_field_controller"
application.register("multi-select-field", MultiSelectFieldController)

import MyRadarChartController from "./my_radar_chart_controller"
application.register("my-radar-chart", MyRadarChartController)

import NotificationsController from "./notifications_controller"
application.register("notifications", NotificationsController)

import OutboundAffiliateAssignController from "./outbound_affiliate_assign_controller"
application.register("outbound-affiliate-assign", OutboundAffiliateAssignController)

import OutboundWorkflowAssignController from "./outbound_workflow_assign_controller"
application.register("outbound-workflow-assign", OutboundWorkflowAssignController)

import OtherAffiliateLinkController from "./other_affiliate_link_controller"
application.register("other-affiliate-link", OtherAffiliateLinkController)

import PasswordVisibilityController from "./password_visibility_controller"
application.register("password-visibility", PasswordVisibilityController)

import PushSubscriptionController from "./push_subscription_controller"
application.register("push-subscription", PushSubscriptionController)

import PostLinkController from "./post_link_controller"
application.register("post-link", PostLinkController)

import RadioButtonPairController from "./radio_button_pair_controller"
application.register("radio-button-pair", RadioButtonPairController)

import RangeController from "./range_controller"
application.register("range", RangeController)

import ReportExpandController from "./report_expand_controller"
application.register("report-expand", ReportExpandController)

import ReportAccessController from "./report_access_controller"
application.register("report-access", ReportAccessController)

import AppUsageTableController from "./app_usage_table_controller"
application.register("app-usage-table", AppUsageTableController)

import RegistrationLinkFormController from "./registration_link_form_controller"
application.register("registration-link-form", RegistrationLinkFormController)

import SelfAssessmentLinkFormController from "./self_assessment_link_form_controller"
application.register("self-assessment-link-form", SelfAssessmentLinkFormController)

import RegistrationFormController from "./registration_form_controller"
application.register("registration-form", RegistrationFormController)

import LinkFormController from "./link_form_controller"
application.register("link-form", LinkFormController)

import RevealController from "./reveal_controller"
application.register("reveal", RevealController)

import SearchController from "./search_controller"
application.register("search", SearchController)

import SearchAffiliatesController from "./search_affiliates_controller"
application.register("search-affiliates", SearchAffiliatesController)

import SessionTimeoutController from "./session_timeout_controller"
application.register("session-timeout", SessionTimeoutController)

import SignatureStylePickerController from "./signature_style_picker_controller"
application.register("signature-style-picker", SignatureStylePickerController)

import TextInputFieldController from "./text_input_field_controller"
application.register("text-input-field", TextInputFieldController)

import ToggleFormController from "./toggle_form_controller"
application.register("toggle-form", ToggleFormController)

import UsersController from "./users_controller"
application.register("users", UsersController)

import UserAffiliationsController from "./user_affiliations_controller"
application.register("user-affiliations", UserAffiliationsController)

import UserWorkflowsController from "./user_workflows_controller"
application.register("user-workflows", UserWorkflowsController)

import SmartabaseMatchController from "./smartabase_match_controller"
application.register("smartabase-match", SmartabaseMatchController)

import SmartabaseReviewRowController from "./smartabase_review_row_controller"
application.register("smartabase-review-row", SmartabaseReviewRowController)

import WorkflowBuilderController from "./workflow_builder_controller"
application.register("workflow-builder", WorkflowBuilderController)

import WorkflowUsersController from "./workflow_users_controller"
application.register("workflow-users", WorkflowUsersController)

import WorkflowBulkAssignController from "./workflow_bulk_assign_controller"
application.register("workflow-bulk-assign", WorkflowBulkAssignController)
